import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from 'components/typography/Text';
import { Image as SemanticImage } from 'semantic-ui-react';
import accommodationSrc from 'assets/media/eden/my-workspace/accommodation.jpeg';
import styles from '../styles.module.scss';

export const Accommodation = () => (
  <>
    <SemanticImage
      src={accommodationSrc}
      alt="Accommodation"
      className={styles.image}
    />

    <Text size={16}>
      <FormattedMessage
        id="accommodationDescription"
        values={{
          bold: (...chunks) => (
            <Text
              size={16}
              element="span"
              bold
            >
              {chunks}
            </Text>
          ),
        }}
      />
    </Text>
  </>
);
